import { render } from "./PainelView.vue?vue&type=template&id=4b943a07&scoped=true"
import script from "./PainelView.vue?vue&type=script&lang=js"
export * from "./PainelView.vue?vue&type=script&lang=js"

import "./PainelView.vue?vue&type=style&index=0&id=4b943a07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b943a07"]])

export default __exports__